import Api from './Api'

export default {
    setDadosComerciais(formData){
        return Api().post('socio/dadosComerciais', formData);
    }
}
